import { getAppList, getAppConfig } from '../lib/appsRegistry';
import { initialState as userInit } from '../../core/store/User/reducer';
import { initialState as companyInit } from '../../core/store/Company/reducer';
import { initialState as appInit } from '../../core/store/App/reducer';

export const buildReducerEntries = async ({ companyName } = {}) => {
  const appList = await getAppList({ companyName });
  const reducersResult = {};
  appList.forEach(app => {
    const { reducers } = app;
    if (typeof reducers === 'function') {
      Object.assign(reducersResult, reducers());
    }
  });
  return reducersResult;
};

const buildConfInitState = async appConfig => {
  const { reduxInitialisers } = appConfig;
  if (!reduxInitialisers) return {};

  delete reduxInitialisers.user;
  delete reduxInitialisers.company;
  delete reduxInitialisers.app;
  delete reduxInitialisers.apollo;
  return reduxInitialisers;
};

export const buildInitialState = async (props = {}) => {
  const { user, company, resetPasswordToken, invitationToken, ...rest } = props;

  let companyName = null;
  if (company) {
    companyName = company.subdomain;
  }
  const appConfig = await getAppConfig({ companyName });
  const confInitState = await buildConfInitState(appConfig);
  const initState = {
    user: {
      ...userInit,
      userProfile: { ...user },
      resetPasswordToken,
      invitationToken,
    },
    company: { ...companyInit, ...company },
    app: {
      ...appInit,
      config: appConfig,
      serverParams: rest,
    },
    ...confInitState,
  };

  return initState;
};
